import { addHours, format, parse, differenceInHours } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { isEmpty, isNumber } from 'lodash';

export const parseDate = (date: string | undefined) => {
  // 25-01-2025
  if (date && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
    return parse(date, 'dd-MM-yyyy', new Date());
  }
  throw new Error(`parseDate error: ${date} is incorrect format`);
};

export const parseTime = (time: string | undefined) => {
  if (time && /^\d{2}:\d{2}:\d{2}$/.test(time)) {
    return parse(time, 'HH:mm:ss', new Date());
  }
  throw new Error(`parseTime error: ${time} is incorrect format`);
};

export const formatTimeToAmPm = (time: string | undefined, increment?: number) => {
  let parsedTime = parseTime(time);
  if (increment) {
    parsedTime = addHours(parseTime(time), increment);
  }
  return format(parsedTime, 'h:mmaaa');
};

export const formatToFullDate = (date: string | undefined) => {
  return format(parseDate(date), 'EEEE do MMM yyyy');
};

// check if time has passed (in hours)
export const isTimeExpired = (date: string, timezone: string | undefined, gap: number) => {
  // skip calcualation if data is broken
  if (isEmpty(date) || typeof timezone === 'undefined' || isEmpty(timezone) || !isNumber(gap)) {
    return false;
  }

  const slotTime = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
  const currentZoneTime = toZonedTime(new Date(), timezone);
  const hoursDifference = differenceInHours(slotTime, currentZoneTime);

  return hoursDifference < gap;
};
